import { useTranslation } from "react-i18next";
import { setLanguage } from "../i18n";

const LANGS = [
  { code: "es" as const, label: "ES" },
  { code: "en" as const, label: "EN" },
];

/**
 * DDX-only UI-chrome language toggle — distinct from OE-016's per-actor
 * response_language (that governs what language the AI assistant replies
 * in during POD/SalesRoom conversations; this governs DDX's own labels).
 * Rendered via AppShell's headerExtra slot, scoped to this Native System.
 */
export function LanguageSelector() {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "es";

  return (
    <div role="group" aria-label="Idioma" style={{ display: "flex", gap: 4 }}>
      {LANGS.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => setLanguage(code)}
          aria-pressed={current === code}
          style={{
            cursor: "pointer",
            fontSize: "var(--ax-type-sm)",
            fontWeight: current === code ? 700 : 400,
            opacity: current === code ? 1 : 0.7,
            background: "transparent",
            border: "1px solid color-mix(in srgb, #ffffff 40%, transparent)",
            borderRadius: 4,
            color: "inherit",
            padding: "8px 10px",
            minHeight: 36,
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
